import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VIEW_ALL_TYPES } from '@app/mpp/shared/enum/ingredient-enum';
import { IngredientSearchResult } from '@app/mpp/shared/model/ingredient-search-result';
import { PlatformEnum } from '@panamax/app-state';
import { FEATURES } from '@shared/constants/splitio-features';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-ingredient-search-product',
  templateUrl: './ingredient-search-product.component.html',
  styleUrls: ['./ingredient-search-product.component.scss'],
})
export class IngredientSearchProductComponent {
  @Input() searchKey: string;
  @Input() ingredientSearchResult$: Observable<IngredientSearchResult[]>;
  @Input() viewAllState: VIEW_ALL_TYPES;
  @Input() platform: PlatformEnum;
  @Input() searchTimeoutTracker: boolean;
  @Output() selectIngredientToAddEvent =
    new EventEmitter<IngredientSearchResult>();
  @Output() viewAllEvent = new EventEmitter<void>();
  platformRef = PlatformEnum;
  readonly split_global_product_price_per_portion_card_flag =
    FEATURES.split_global_product_price_per_portion_card_flag.name;
  constructor() {}

  selectIngredientToAdd(ingredient: IngredientSearchResult) {
    this.selectIngredientToAddEvent.emit(ingredient);
  }

  viewAllProducts() {
    this.viewAllEvent.emit();
  }
}
